import React, { useState } from 'react';
import { 
  Button, 
  Dialog, 
  IconButton, 
  Paper, 
  Slide, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableRow, 
  Typography,
  styled
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

// Componentes estilizados
const StyledDialogTitle = styled('div')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(2),
  position: 'relative',
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[500],
}));

const StyledDialogContent = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
}));

const StyledDialogActions = styled('div')(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));

const StyledTableCell = styled(TableCell)({
  paddingLeft: '8px',
  paddingRight: '0px',
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FichaPropertyDialog = ({ open, handleClose, data }) => {
  const [estadoSeleccionado, setEstadoSeleccionado] = useState(null);
  
  const handleEstadoChange = estado => {
    setEstadoSeleccionado(estado);
  };

  return (
    <Dialog 
      onClose={handleClose} 
      aria-labelledby="customized-dialog-title" 
      open={open}
      TransitionComponent={Transition}
    >
      <StyledDialogTitle>
        <Typography variant="h6" style={{ marginRight: '38px' }}>
          Id: {data.id} - {data.evento}
        </Typography>
        {handleClose ? (
          <CloseButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
        ) : null}
      </StyledDialogTitle>
      
      <StyledDialogContent dividers>
        <TableContainer component={Paper} style={{ backgroundColor: '#F8F9F9' }}>
          <Table>
            <TableBody>
              <TableRow>
                <StyledTableCell><strong>Código interno:</strong></StyledTableCell>
                <StyledTableCell>{data.codeInternal}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell><strong>Año:</strong></StyledTableCell>
                <StyledTableCell>{data.year}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell><strong>Owner Id:</strong></StyledTableCell>
                <StyledTableCell>{data.ownerId}</StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </StyledDialogContent>
      
      <StyledDialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          Cerrar
        </Button>
      </StyledDialogActions>
    </Dialog>
  );
};

export default FichaPropertyDialog;